var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17188 10.4844H7.03125V12.5938H4.6875V13.5312H10.3125V12.5938H7.96875V10.4844H13.8281C14.0145 10.4842 14.1933 10.41 14.3251 10.2782C14.4569 10.1464 14.531 9.96766 14.5312 9.78125V1.10938C14.531 0.922961 14.4569 0.744245 14.3251 0.61243C14.1933 0.480616 14.0145 0.406467 13.8281 0.40625H1.17188C0.985461 0.406467 0.806745 0.480616 0.67493 0.61243C0.543116 0.744245 0.468967 0.922961 0.46875 1.10938V9.78125C0.468967 9.96766 0.543116 10.1464 0.67493 10.2782C0.806745 10.41 0.985461 10.4842 1.17188 10.4844ZM1.40625 1.34375H13.5938V9.54688H1.40625V1.34375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.4666a50db63e8467b656160dcf2bbdd4.svg";
export { ForwardRef as ReactComponent };